var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"max-height":"90vh","height":"100%"}},[_c('chat-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }